import dynamic from 'next/dynamic';

import { createSubMenuLink } from '@hultafors/hultaforsgroup/helpers';
import {
  ItemRecord,
  SubMenuItemFragment,
} from '@hultafors/hultaforsgroup/types';

import { SlideIn, SlideInToggler } from '../slide-in/slide-in';
import styles from './desktop-menu.module.scss';
import { DesktopMenuContent, DesktopMenuList } from './desktop-menu.styled';

const Link = dynamic(() =>
  import('@hultafors/shared/components').then((module) => module.SharedLink),
);

interface DesktopMenuProps {
  menuItems: SubMenuItemFragment[];
  menuType?: string;
  openType?: string;
  partnerPortalUrl?: string;
  toggleDesktopMenu: SlideInToggler;
}

export const DesktopMenu: React.FC<DesktopMenuProps> = ({
  menuItems,
  menuType,
  openType,
  toggleDesktopMenu,
}) => {
  const onClick = () => toggleDesktopMenu();

  const menuItemsMapper = (item: SubMenuItemFragment, i: number) => (
    <Link
      className={styles['link']}
      href={createSubMenuLink(item as ItemRecord)}
      key={`Product-Menu-${i}`}
      onClick={onClick}
      styleType="p2-paragraph"
    >
      {item.title}
    </Link>
  );

  return (
    <SlideIn
      fromTop
      id="desktopMenu"
      isMenu
      isOpen={openType === menuType}
      noHeader
      toggle={toggleDesktopMenu}
    >
      <DesktopMenuContent>
        <DesktopMenuList>{menuItems.map(menuItemsMapper)}</DesktopMenuList>
      </DesktopMenuContent>
    </SlideIn>
  );
};
